import { render, staticRenderFns } from "./Apartments.vue?vue&type=template&id=251c1af6&scoped=true&"
import script from "./Apartments.vue?vue&type=script&lang=js&"
export * from "./Apartments.vue?vue&type=script&lang=js&"
import style0 from "./Apartments.vue?vue&type=style&index=0&id=251c1af6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251c1af6",
  null
  
)

export default component.exports